<template>
    <div class="index hml_whplt">
        <audioButton :option="{isMusicShow: true}"></audioButton>
        <div class="domBox hml_whplt" @click="domBoxClick">
            <video src="https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/video/indexVideo.mp4" ref="video" style="width:100%;height:100%;object-fit:fill;" :controls="false" x5-video-player-type="h5-page" webkit-playsinline="true" playsinline="true" loop id='video' autoplay v-if="videoShow"></video>
            <!-- <video
            src="https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/video/indexVideo.mp4"
            ref="video"
            style="width:100%;height:100%;object-fit:fill;"
            :controls="false"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portrait"
            loop
            id='video'
            autoplay
            v-if="videoShow"></video> -->

            <!-- <div class="indexSiper swiper-container hml_whplt swiper-no-swiping">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide"
                    v-for="(item,index) in 10"
                    :key="index"
                    >
                        <img :src="require('@/assets/img/index/indexBg0'+ (index + 1) +'.jpg')">
                    </li>
                </ul>
            </div> -->
        
        </div>
        <transition name="titleImg">
            <div class="titleImg" v-show="titleImgShow">
                <img src="@/assets/img/index/title.png">
            </div>
        </transition>
        <transition name="titleImg">
            <ul class="list" v-show="listShow">
                <li
                v-for="(item,index) in allData"
                :key="index"
                @click="listClick(item)"
                v-show="index < 5"
                >
                    <!-- {{ item.title }} -->
                    <img :src="item.url">
                </li>
                <p class="banquan">京山市文化和旅游局 | 武汉禾木林科技有限公司</p>
            </ul> 
        </transition>
        <transition name="titleImg2">
            <div class="cover hml_whplt" v-if="coverShow && pageShow" @click="textBoxClick">
                <transition name="titleImg1">
                    <img src="@/assets/img/index/coverImg.png" class="coverImg" v-if="coverImgShow">
                </transition>
                <transition name="titleImg1">
                    <div class="textBox" v-if="textBoxShow">
                        <img src="@/assets/img/index/coverText.png" alt="" class="coverText">
                        <img src="@/assets/img/index/coverArrow.png" alt="" class="coverArrow">
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import audioButton from "@/components/audioButton";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() {
        return {
            titleImgShow: false,
            listShow: false,
            coverShow: false,
            coverImgShow: false,
            textBoxShow: false,
            videoShow: false
        }
    },
    created(){
        if(this.isWeiXin()){
            this.videoShow = true
        }else{
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(isiOS){
                this.videoShow = true
            }else{

            }
        }
        this.addDataSort();
        // console.log(this.allData);
        this.setIndex({firstLevelIndex: -1,secondLevelIndex: 0,levelThreeIndex: 0});
        this.setGetIntoTheState(0);
        this.setMapJumpListFlag(false);
        if(this.indexGetIntoState){
            this.coverShow = false;
            this.titleImgShow = true;
            this.listShow = true;
        }
    },
    mounted(){
        if(this.indexGetIntoState){
            // this.$refs.video.play();
            if(this.isWeiXin()){
                this.$refs.video.play();
            }else{
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    this.$refs.video.play();
                }else{

                }
            }
        }else{
            this.coverShow = true;
            this.coverImgShow = true;
            setTimeout(() => {
                this.textBoxShow = true;
                this.setIndexGetIntoState();
            },1000);
            // this.titleImgShow = true;
            // setTimeout(() => {
            //     this.listShow = true;
            //     this.setIndexGetIntoState();
            // },1000);
            
        }
        // let urlParameter = this.GetRequest();
        // if(urlParameter.firstLevelIndex != -1){
        //     this.listClick(this.allData[urlParameter.firstLevelIndex])
        // }
        /* this.swiper = new Swiper('.indexSiper',{
            loop: true,
            speed: 4000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                waitForTransition: true,
            }
        }); */
        
    },
    methods: {
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            // 判断是否在微信中打开
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return true;
            } else {
                return false;
            }
        },
        textBoxClick(){
            if(this.isWeiXin()){
                this.$refs.video.play();
            }else{
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    this.$refs.video.play();
                }else{

                }
            }
            document.getElementById("music").play();
            this.textBoxShow = false;
            this.coverImgShow = false;
            this.coverShow = false;
            setTimeout(() => {
                this.titleImgShow = true;
                this.listShow = true;
            },1000); 
        },
        domBoxClick(){
            // this.$refs.video.play();
        },
        listClick(item){
            this.setIndex({firstLevelIndex: item.firstLevelIndex});
            if(item.firstLevelIndex == 4){
                this.$router.push("/map")
            }else{
                this.$router.push({name: this.allData[item.firstLevelIndex].dataArr[0].routerName});
            }
        },
        ...publicData.mapMutations(["setIndex","setGetIntoTheState","setMapJumpListFlag","setIndexGetIntoState","addDataSort"])
    },
    computed: {
        ...publicData.mapState(["pageShow","allData","indexGetIntoState"])
    },
    components: {
        audioButton
    },
}
</script>

<style lang="scss" scoped>
.index{
    .cover{
        background: rgba(0,0,0,.4);
        z-index: 10;
        .coverImg{
            width: 1.2rem;
            height: 5.18rem;
            position: absolute;
            left: 50%;
            top: 1.66rem;
            transform: translateX(-50%);
        }
        .textBox{
            width: 3.8rem;
            height: .86rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 1.66rem;
            .coverText{
                width: 100%;
                height: 100%;
            }
            .coverArrow{
                width: .46rem;
                height: .22rem;
                position: absolute;
                right: .4rem;
                top: 50%;
                transform: translateY(-50%);
                animation: arrow 1s linear 0s infinite;
            }
        }
    }
    // background: #0BCFCA;
    .titleImg{
        width: 4.42rem;
        height: 6.72rem;
        position: absolute;
        left: 0rem;
        top: .24rem;
        z-index: 2;
    }
    .domBox{
        background: url(https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/video/indexBg.jpg) no-repeat;
        // background: #0cf;
        background-size: 100% 100%;
        z-index: 0;
        .indexSiper{
            ul{
                transition-timing-function: linear;
            }
        }
    }
    .list{ 
       width: 100%;
        padding: 0 .3rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        position: absolute;
        left: 0;
        bottom: 1.2rem;
        li{
            width: 1.18rem;
            height: 1.88rem;
            // font-size: .36rem;
            // color: #333;
            // width: 100%;
            // height: .8rem;
            // border: .02rem solid #fff;
            // margin-top: .2rem;
            // display: flex;
            // align-items: center;
            // justify-content: center;
        }
        .banquan{
                width: 100%;
                white-space: nowrap;
                font-size: .22rem;
                color: hsla(0,0%,100%,.9);
                position: absolute;
                left: 0;
                bottom: -.7rem;
                text-align: center;
        }
    }
}
@keyframes arrow {
    0%{
        transform: translateX(0rem,-50%);
    }
    50%{
        transform: translate(.2rem,-50%);
    }
    100%{
        transform: translateX(0rem,-50%);
    }
}
.titleImg-enter,.titleImg-leave-to {
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.titleImg-enter-active,.titleImg-leave-active {
	transition: all 1s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.titleImg-enter-to,.titleImg-leave {
	opacity: 1;
}
.titleImg1-enter,.titleImg1-leave-to {
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.titleImg1-enter-active{
	transition: all 2s ease;
}
.titleImg1-leave-active{
    transition: all 1s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.titleImg1-enter-to,.titleImg1-leave {
	opacity: 1;
}
.titleImg2-enter,.titleImg2-leave-to {
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.titleImg2-enter-active{
	transition: all 1s ease;
}
.titleImg2-leave-active{
    transition: all 1s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.titleImg2-enter-to,.titleImg2-leave {
	opacity: 1;
}
</style>